import { render, staticRenderFns } from "./MailTemplates.vue?vue&type=template&id=f44dffc4"
import script from "./MailTemplates.vue?vue&type=script&lang=js"
export * from "./MailTemplates.vue?vue&type=script&lang=js"
import style0 from "./MailTemplates.vue?vue&type=style&index=0&id=f44dffc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports